import { gql } from "lib/apolloClient";
import { organizationUnitPlanFeedFragment } from "./AssessmentSelectModalFragments";

export const getOrganizationUnitPlanFeedQuery = gql`
  query getOrganizationUnitPlanFeed(
    $id: ID!
    $filters: UnitPlansV2FeedFilters!
    $after: String
    $centralRepoInput: UnitCentralRepoConfigInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationUnitPlanFeedItem
      }
    }
  }
  ${organizationUnitPlanFeedFragment.organizationUnitPlanFeedV2}
`;

export const getUnitSectionFilterDataQuery = gql`
  query getUnitSectionFilterDataQuery(
    $organizationId: ID!
    $coursesFilters: CourseFilterInput
    $skipSubjects: Boolean!
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(
          orderBy: TITLE
          orderByDirection: ASC
          filters: $coursesFilters
        ) {
          edges {
            node {
              id
              title
              isArchived
            }
          }
        }
        grades {
          id
          name
          globalGrade {
            id
            uid
            name
            constants
          }
        }
        subjects @skip(if: $skipSubjects) {
          id
          name
          icon
        }
      }
    }
  }
`;
